<template>
    <div class="container">
      <div class="swiper-container-group">
        <div class="swiper-container" ref="mySwiper">
          <div class="swiper-wrapper">
            <div class="swiper-slide-MARKET swiper-slide" v-if="marketEnum.includes(versionType)">
              <div class="adjust-type new-version-title">营销版</div>
            </div>
            <div class="swiper-slide-EDU swiper-slide" v-if="eduEnum.includes(versionType)">
              <div class="adjust-type  new-version-title">教务版</div>
            </div>
            <div class="swiper-slide-NEWLEAD swiper-slide">
              <div class="adjust-type-desc  new-version-title">
                <div class="title">经典版</div>
                <div class="desc">￥3980/年</div>
              </div>
              
            </div>
            <div class="swiper-slide-SENIOR swiper-slide">
                <div class="adjust-type-desc  new-version-title">
                <div class="title">高级版</div>
                <div class="desc">￥5480/年</div>
              </div>
            </div>
            <div class="swiper-slide-PEAK swiper-slide">
                <div class="adjust-type-desc  new-version-title">
                <div class="title">巅峰版</div>
                <div class="desc">￥7480/年</div>
              </div>
            </div>
            <!-- <div :class="`swiper-slide-${item.type}  swiper-slide` " v-for="(item) in swiperList" :key="item.type">
                <div class="adjust-type-desc  new-version-title" v-if="item.desc">
                    <div class="title">{{ item.name }}{type}</div>
                   <div class="desc">{{ item.desc }}</div>
                 </div>
                 <div class="adjust-type  new-version-title" v-else>{{ item.name }}</div>
            </div> -->
          </div>
          <div class="swiper-pagination" slot="pagination"></div>
        </div>
        <div class="back-white"></div>
        <div v-if="!isExpanded" class="bg-img">
          <template v-for="(item, index) in imgs[type]">
            <div :key="item">
              <img :src="item" alt="" />
              <div class="expand-wrap" v-if="index === 0">
                <div v-if="!isExpanded" class="expand" @click="clickExpand">展开 <img :src="downIcon" alt="" /></div>
                <div v-else class="expand" @click="clickExpand">收起 <img :src="upIcon" alt="" /></div>
              </div>
            </div>
          </template>
        </div>
  
        <div v-else class="bg-img">
          <div class="expand not" @click="clickExpand"></div>
          <template v-for="item in expandImgs[type]">
            <img :src="item" alt="" :key="item" />
          </template>
          <div class="expand-wrap">
            <div v-if="!isExpanded" class="expand" @click="clickExpand">展开 <img :src="downIcon" alt="" /></div>
            <div v-else class="expand" @click="clickExpand">收起 <img :src="upIcon" alt="" /></div>
          </div>
        </div>
      </div>
    </div>
  </template>
  <script>
  export default {
    name: 'newPackage',
    props: ['isShowBasic','versionType'],
    data() {
      const t = new Date(new Date().toLocaleDateString()).getTime();
      return {
        type: 'market',
        initialSlide: 0,
        isExpanded: false, // 是否展开
        downIcon: 'https://image.xiaomaiketang.com/xm/internal/Y7saA4WSY7.png',
        upIcon: 'https://image.xiaomaiketang.com/xm/internal/pyH22tENAY.png',
        left: 'https://image.xiaomaiketang.com/xm/Xe38ktyQkb.png',
        right: 'https://image.xiaomaiketang.com/xm/ZhPsZQWiYM.png',
        swiperList:[ ],
        xmversion: null,
        marketEnum:['MARKET'],
        eduEnum:['EDU'],
        imgs: {
          market: ['https://image.xiaomaiketang.com/xm/internal/Tish7CARPQ.png', 'https://image.xiaomaiketang.com/xm/internal/ww2JssmYSz.png'],
          edu: ['https://image.xiaomaiketang.com/xm/internal/4ErwZb4Q7n.png', 'https://image.xiaomaiketang.com/xm/internal/RTt776M57m.png'],
          newLead: ['https://image.xiaomaiketang.com/xm/internal/3hYCHasB3h.png', 'https://image.xiaomaiketang.com/xm/internal/H4MRDsHWYE.png'],
          senior: ['https://image.xiaomaiketang.com/xm/internal/7wJWhs8xbB.png', 'https://image.xiaomaiketang.com/xm/internal/fHzbSbHAbr.png'],
          peak: ['https://image.xiaomaiketang.com/xm/internal/TfybJaKAGH.png', 'https://image.xiaomaiketang.com/xm/internal/r7XFyYcG68.png'],
        },
        expandImgs: {
            market: [
            'https://image.xiaomaiketang.com/xm/internal/Tish7CARPQ.png',
            'https://image.xiaomaiketang.com/xm/internal/WCFAn78JkZ.png',
            `https://image.xiaomaiketang.com/xm/internal/ww2JssmYSz.png?t=${t}`,
          ],
          edu: [
            'https://image.xiaomaiketang.com/xm/internal/4ErwZb4Q7n.png',
            'https://image.xiaomaiketang.com/xm/internal/XpDH3PhXfB.png',
            `https://image.xiaomaiketang.com/xm/internal/RTt776M57m.png?t=${t}`,
          ],
          newLead: [
            'https://image.xiaomaiketang.com/xm/internal/3hYCHasB3h.png',
            'https://image.xiaomaiketang.com/xm/internal/rfyYzseGWb.png',
            `https://image.xiaomaiketang.com/xm/internal/H4MRDsHWYE.png?t=${t}`,
          ],
          senior: [
            'https://image.xiaomaiketang.com/xm/internal/7wJWhs8xbB.png',
            'https://image.xiaomaiketang.com/xm/internal/t274t8d3n5.png',
            `https://image.xiaomaiketang.com/xm/internal/fHzbSbHAbr.png?t=${t}`,
          ],
          peak: [
            'https://image.xiaomaiketang.com/xm/internal/TfybJaKAGH.png',
            'https://image.xiaomaiketang.com/xm/internal/3i2zHbb7Nz.png',
            `https://image.xiaomaiketang.com/xm/internal/r7XFyYcG68.png?t=${t}`,
          ],
        },
      };
    },
    methods: {
      init() {
        const _this = this;
        var swiper = new Swiper('.swiper-container', {
          slidesPerView: 1.16,
          spaceBetween: 8,
          centeredSlides: true,
          // initialSlide: _this.initialSlide >= 4 ? this.initialSlide - 1 : _this.initialSlide,
          initialSlide: _this.initialSlide,
          on: {
            // 动画结束后更改对应的数据
            slideChangeTransitionEnd: function() {
              const index = this.activeIndex;
              let newTypes = ['newLead', 'senior', 'peak'];
                if(_this.versionType==='MARKET'){
                    newTypes = ['market', 'newLead', 'senior', 'peak']
                }else if(_this.versionType==='EDU'){
                    newTypes = ['edu','newLead', 'senior', 'peak']
                }
                _this.type = newTypes[index];
            },
          },
          pagination: {
            el: '.swiper-pagination',
            clickable: true,
          },
        });
        swiper.update()
      },
      // 通过URL获取当前版本
      parseUrl() {
         if(this.versionType==='EDU'){
           this.type= 'edu'
        }else if(this.versionType==='NEWLEAD'){
            this.type='newLead'
        }else if(this.versionType==='SENIOR'){
            this.type='senior'
            this.initialSlide=1
        } else if(this.versionType==='PEAK'){
           this.initialSlide=2
           this.type='peak'
        }
      },
  
      clickExpand() {
        this.isExpanded = !this.isExpanded;
      },
    },
    computed: {
      swiper() {
        return this.$refs.mySwiper.$swiper;
      },
    },
    mounted() {
      this.parseUrl();
      this.init();
    },
  };
  </script>
  
  <style lang="less">
  .container {
    height: 100vh;
    overflow: scroll;
    font-family: PingFangSC-Regular, PingFang SC;
    background: #ffffff;
    .swiper-container-group {
      width: 100vw;
      height: 198px;
      padding-top: 34px;
      background: #fff3e1;
    }
    .back-white {
      width: 0;
      height: 0;
      border-top: 36px solid transparent;
      border-left: 50vw solid #ffffff;
      border-right: 50vw solid #ffffff;
      // border: 10px solid red;
      position: relative;
      top: -36px;
      z-index: 999;
    }
    .swiper-slide-MARKET {
      background-image: url('https://image.xiaomaiketang.com/xm/internal/3tSZhyXQ5X.png');
      background-size: 100% 100%;
      .adjust-type{
        color: #AC5633;
      }
     
    }
    .swiper-slide-EDU {
      background-image: url('https://image.xiaomaiketang.com/xm/internal/PQxYed35P2.png');
      background-size: 100% 100%;
      .adjust-type{
        color: #3680C1;
      }
    }
    .swiper-slide-NEWLEAD {
      height: 100%;
      overflow: auto;
      background-image: url('https://image.xiaomaiketang.com/xm/internal/52swkdZZKd.png');
      background-size: 100% 100%;
      .adjust-type-desc{
        color: #AD5307;
      }
    }
    .swiper-slide-SENIOR {
      height: 100%;
      overflow: auto;
      background-image: url('https://image.xiaomaiketang.com/xm/internal/PMe6xP2B4G.png');
      background-size: 100% 100%;
      .adjust-type-desc{
        color: #AD5307;
      }
    }
    .swiper-slide-PEAK {
      height: 100%;
      overflow: auto;
      background-image: url('https://image.xiaomaiketang.com/xm/internal/bisH2wbbmS.png');
      background-size: 100% 100%;
      .adjust-type-desc{
        color: #341D64;
      }
    }
  
    .swiper-container {
      height: 195px;
      width: 100vw;
      .swiper-pagination-bullet {
        width: 5px;
        height: 5px;
        &.swiper-pagination-bullet-active {
          background: #fff;
        }
      }
      img {
        width: 100%;
        height: 100%;
      }
      .adjust-type {
        width: 100%;
        height: 100%;
        font-size: 23px;
        font-weight: 500;
        text-align: center;
        justify-content: center;
        align-items: center;
        display: flex;
        font-weight: 500;
      }
      .adjust-type-desc{
        width: 100%;
        height: 100%;
        font-size: 23px;
        font-weight: 500;
        text-align: center;
        justify-content: center;
        display: flex;
        font-weight: 500;
        flex-wrap: wrap;
        flex-direction: column;
        .title{
            font-size: 23px;
            font-weight: 500;
            width: 100%;
            flex: none;
        }
        .desc{
            font-size: 23px;
            font-weight: 500;
            width: 100%;
            flex: none;
        }
      }
      .new-version-title {
        width: 100%;
        height: 100%;
        position: relative;
        top: 50%;
        transform: translateY(-50%);
        margin-top: 0 !important;
        //  font-size: .46rem !important;
      }
      .adjust-money {
        width: 250px;
        height: 21px;
        font-size: 17px;
        margin: auto;
        margin-top: 22px;
        font-weight: 500;
        line-height: 21px;
      }
      .adjust-money-number {
        font-size: 35px;
        font-weight: bold;
      }
      .adjusts-money {
        width: 250px;
        height: 21px;
        font-size: 17px;
        margin: auto;
        margin-top: 42px;
        font-weight: 500;
        line-height: 21px;
      }
    }
    .adjust-service-group {
      height: calc(~'100vh - 160px'); /* 计算除了轮播图的其他内容的高度 */
      .card-content {
        text-align: center;
        width: 328px;
        height: 36px;
        margin: auto;
        font-size: 13px;
        font-weight: 400;
        color: #999999;
        line-height: 18px;
        padding: 55px 15px 30px 15px;
        background: #ffffff;
      }
      .adjust-service-title {
        &.market-function {
          margin-bottom: 13px;
        }
        &.branch-tasting,
        &.study-inline,
        &.add-value {
          margin-bottom: 8px;
        }
        span {
          font-size: 15px;
          font-weight: 500;
          color: #333333;
          line-height: 21px;
          margin: 0 8px;
          vertical-align: middle;
        }
        img {
          width: 12px;
          height: 8px;
        }
      }
    }
    .bg-img {
      position: relative;
      font-size: 0;
      img {
        width: 100%;
      }
  
      .expand-wrap {
        text-align: center;
        margin-top: 0.32rem;
        padding-bottom: 0.48rem;
        .expand {
          display: inline-block;
          font-size: 0.28rem;
          line-height: 0.4rem;
          color: #999999;
  
          img {
            width: 0.28rem;
            line-height: 0.4rem;
            vertical-align: -0.04rem;
          }
        }
      }
    }
  }
  </style>
  


// WEBPACK FOOTER //
// src/module/renew/fourVision.vue